import {
  Entity,
  Column,
  PrimaryGeneratedColumn,
  JoinColumn,
  Index,
  ManyToOne,
  OneToMany
} from "typeorm";
import { User, WorkLicenseType, LicenseRequest, Upload } from ".";

@Entity()
@Index(["musicMaestroId", "version"], { unique: true })
@Index(["openPlayId", "version"], { unique: true })
@Index(["uploadId", "version", "deletedAt"])
@Index(["uploadId"])
@Index(["version"])
@Index(["deletedAt"])
export class Work {
  @PrimaryGeneratedColumn() id: number;

  @Column("varchar", { nullable: true })
  title: string;
  @Column("varchar", { nullable: true })
  songTitle: string;
  @Column("varchar", { nullable: true })
  workType: string;
  @Column("varchar", { nullable: true })
  songVersion: string;
  @Column("text", { nullable: true })
  akas: string;
  @Column("varchar", { nullable: true })
  ccliNumber: string;
  @Column("datetime", { nullable: true })
  copyrightDate: Date;
  @Column("varchar", { nullable: true })
  totalImPercentControl: string;
  @Column("varchar", { nullable: true })
  territoryControlled: string;
  @Column("varchar", { nullable: true })
  region: string;
  @Column("varchar", { nullable: true, length: 1024 })
  copyrightNotice: string;
  @Column("varchar", { nullable: true })
  writer1: string;
  @Column("int", { nullable: true })
  writer1Percentage: number;
  @Column("varchar", { nullable: true })
  writer2: string;
  @Column("int", { nullable: true })
  writer2Percentage: number;
  @Column("varchar", { nullable: true })
  writer3: string;
  @Column("int", { nullable: true })
  writer3Percentage: number;
  @Column("varchar", { nullable: true })
  writer4: string;
  @Column("int", { nullable: true })
  writer4Percentage: number;
  @Column("varchar", { nullable: true })
  writer5: string;
  @Column("int", { nullable: true })
  writer5Percentage: number;
  @Column("varchar", { nullable: true })
  writer6: string;
  @Column("int", { nullable: true })
  writer6Percentage: number;
  @Column("varchar", { nullable: true })
  writer7: string;
  @Column("int", { nullable: true })
  writer7Percentage: number;
  @Column("varchar", { nullable: true })
  writer8: string;
  @Column("int", { nullable: true })
  writer8Percentage: number;
  @Column("varchar", { nullable: true })
  writer9: string;
  @Column("int", { nullable: true })
  writer9Percentage: number;
  @Column("varchar", { nullable: true })
  publisher1: string;
  @Column("int", { nullable: true })
  publisher1Percentage: number;
  @Column("varchar", { nullable: true })
  publisher2: string;
  @Column("int", { nullable: true })
  publisher2Percentage: number;
  @Column("varchar", { nullable: true })
  publisher3: string;
  @Column("int", { nullable: true })
  publisher3Percentage: number;
  @Column("varchar", { nullable: true })
  publisher4: string;
  @Column("int", { nullable: true })
  publisher4Percentage: number;
  @Column("varchar", { nullable: true })
  publisher5: string;
  @Column("int", { nullable: true })
  publisher5Percentage: number;
  @Column("varchar", { nullable: true })
  publisher6: string;
  @Column("int", { nullable: true })
  publisher6Percentage: number;
  @Column("varchar", { nullable: true })
  publisher7: string;
  @Column("int", { nullable: true })
  publisher7Percentage: number;
  @Column("varchar", { nullable: true })
  publisher8: string;
  @Column("int", { nullable: true })
  publisher8Percentage: number;
  @Column("varchar", { nullable: true })
  publisher9: string;
  @Column("int", { nullable: true })
  publisher9Percentage: number;
  @Column("varchar", { nullable: true })
  publisher10: string;
  @Column("int", { nullable: true })
  publisher10Percentage: number;
  @Column("varchar", { nullable: true })
  publisher11: string;
  @Column("int", { nullable: true })
  publisher11Percentage: number;
  @Column("varchar", { nullable: true })
  publisher12: string;
  @Column("int", { nullable: true })
  publisher12Percentage: number;
  @Column("varchar", { nullable: true })
  publisher13: string;
  @Column("int", { nullable: true })
  publisher13Percentage: number;
  @Column("varchar", { nullable: true })
  publisher14: string;
  @Column("int", { nullable: true })
  publisher14Percentage: number;
  @Column("varchar", { nullable: true })
  publisher15: string;
  @Column("int", { nullable: true })
  publisher15Percentage: number;
  @Column("varchar", { nullable: true })
  publisher16: string;
  @Column("int", { nullable: true })
  publisher16Percentage: number;
  @Column("varchar", { nullable: true })
  publisher17: string;
  @Column("int", { nullable: true })
  publisher17Percentage: number;
  @Column("varchar", { nullable: true })
  publisher18: string;
  @Column("int", { nullable: true })
  publisher18Percentage: number;
  @Column("varchar", { nullable: true })
  publisher19: string;
  @Column("int", { nullable: true })
  publisher19Percentage: number;
  @Column("varchar", { nullable: true })
  publisher20: string;
  @Column("int", { nullable: true })
  publisher20Percentage: number;
  @Column("varchar", { nullable: true })
  publisher21: string;
  @Column("int", { nullable: true })
  publisher21Percentage: number;
  @Column("varchar", { nullable: true })
  publisher22: string;
  @Column("int", { nullable: true })
  publisher22Percentage: number;
  @Column("varchar", { nullable: true })
  publisher23: string;
  @Column("int", { nullable: true })
  publisher23Percentage: number;
  @Column("varchar", { nullable: true })
  publisher24: string;
  @Column("int", { nullable: true })
  publisher24Percentage: number;
  @Column("varchar", { nullable: true })
  publisher25: string;
  @Column("int", { nullable: true })
  publisher25Percentage: number;
  @Column("varchar", { nullable: true })
  publisher26: string;
  @Column("int", { nullable: true })
  publisher26Percentage: number;
  @Column("varchar", { nullable: true })
  publisher27: string;
  @Column("int", { nullable: true })
  publisher27Percentage: number;
  @Column("varchar", { nullable: true })
  albumName: string;
  @Column("datetime", { nullable: true })
  primaryReleaseDate: Date;
  @Column("varchar", { nullable: true })
  releaseArtistName: string;
  @Column("varchar", { nullable: true })
  projectName: string;
  @Column("varchar", { nullable: true })
  trackName: string;
  @Column("varchar", { nullable: true })
  trackArtistName: string;
  @Column("varchar", { nullable: true })
  isrcNumber: string;
  @Column("int", { nullable: true })
  discNumber: number;
  @Column("int", { nullable: true })
  sideNumber: number;
  @Column("int", { nullable: true })
  trackNumber: number;

  @Column("int", { nullable: true })
  version: number;

  @Index()
  @Column("varchar", { nullable: true })
  musicMaestroId: string;

  @Index()
  @Column("varchar", { nullable: true })
  openPlayId: string;

  @Column("int", { nullable: true })
  createdById: number;

  @ManyToOne(() => User)
  @JoinColumn()
  createdBy: User;

  @Column("int", { nullable: true })
  updatedById: number;

  @ManyToOne(() => User)
  @JoinColumn()
  updatedBy: User;

  @OneToMany(() => WorkLicenseType, workLicenseType => workLicenseType.work)
  workLicenseTypes: WorkLicenseType[];

  @OneToMany(() => LicenseRequest, licenseRequest => licenseRequest.work)
  licenseRequests: LicenseRequest[];

  @Column("int", { nullable: true })
  uploadId: number;

  @ManyToOne(() => Upload)
  upload: Upload;

  @Column("datetime") createdAt: Date;
  @Column("datetime") updatedAt: Date;
  @Column("datetime", { nullable: true })
  deletedAt: Date;

  assignAttributesFromObject(obj: any) {
    this.version = obj.version !== undefined ? obj.version : this.version;
    this.updatedBy = obj.updatedBy ? obj.updatedBy : this.updatedBy;
    this.updatedAt = obj.updatedAt ? obj.updatedAt : this.updatedAt;
    this.createdBy = obj.createdBy ? obj.createdBy : this.createdBy;
    this.createdAt = obj.createdAt ? obj.createdAt : this.createdAt;
    this.deletedAt =
      obj.deletedAt !== undefined ? obj.deletedAt : this.deletedAt;
    this.title = obj.title !== undefined ? obj.title : this.title;
    this.songTitle =
      obj.songTitle !== undefined ? obj.songTitle : this.songTitle;
    this.songVersion =
      obj.songVersion !== undefined ? obj.songVersion : this.songVersion;
    this.workType = obj.workType !== undefined ? obj.workType : this.workType;
    this.akas = obj.akas !== undefined ? obj.akas : this.akas;
    this.ccliNumber =
      obj.ccliNumber !== undefined ? obj.ccliNumber : this.ccliNumber;
    this.copyrightDate =
      obj.copyrightDate !== undefined ? obj.copyrightDate : this.copyrightDate;
    this.totalImPercentControl =
      obj.totalImPercentControl !== undefined
        ? obj.totalImPercentControl
        : this.totalImPercentControl;
    this.territoryControlled =
      obj.territoryControlled !== undefined
        ? obj.territoryControlled
        : this.territoryControlled;
    this.region = obj.region !== undefined ? obj.region : this.region;
    this.copyrightNotice =
      obj.copyrightNotice !== undefined
        ? obj.copyrightNotice
        : this.copyrightNotice;
    this.writer1 = obj.writer1 !== undefined ? obj.writer1 : this.writer1;
    this.writer1Percentage = obj.writer1Percentage
      ? obj.writer1Percentage
      : this.writer1Percentage;
    this.writer2 = obj.writer2 !== undefined ? obj.writer2 : this.writer2;
    this.writer2Percentage = obj.writer2Percentage
      ? obj.writer2Percentage
      : this.writer2Percentage;
    this.writer3 = obj.writer3 !== undefined ? obj.writer3 : this.writer3;
    this.writer3Percentage = obj.writer3Percentage
      ? obj.writer3Percentage
      : this.writer3Percentage;
    this.writer4 = obj.writer4 !== undefined ? obj.writer4 : this.writer4;
    this.writer4Percentage = obj.writer4Percentage
      ? obj.writer4Percentage
      : this.writer4Percentage;
    this.writer5 = obj.writer5 !== undefined ? obj.writer5 : this.writer5;
    this.writer5Percentage = obj.writer5Percentage
      ? obj.writer5Percentage
      : this.writer5Percentage;
    this.writer6 = obj.writer6 !== undefined ? obj.writer6 : this.writer6;
    this.writer6Percentage = obj.writer6Percentage
      ? obj.writer6Percentage
      : this.writer6Percentage;
    this.writer7 = obj.writer7 !== undefined ? obj.writer7 : this.writer7;
    this.writer7Percentage = obj.writer7Percentage
      ? obj.writer7Percentage
      : this.writer7Percentage;
    this.writer8 = obj.writer8 !== undefined ? obj.writer8 : this.writer8;
    this.writer8Percentage = obj.writer8Percentage
      ? obj.writer8Percentage
      : this.writer8Percentage;
    this.writer9 = obj.writer9 !== undefined ? obj.writer9 : this.writer9;
    this.writer9Percentage = obj.writer9Percentage
      ? obj.writer9Percentage
      : this.writer9Percentage;
    this.publisher1 =
      obj.publisher1 !== undefined ? obj.publisher1 : this.publisher1;
    this.publisher1Percentage = obj.publisher1Percentage
      ? obj.publisher1Percentage
      : this.publisher1Percentage;
    this.publisher2 =
      obj.publisher2 !== undefined ? obj.publisher2 : this.publisher2;
    this.publisher2Percentage = obj.publisher2Percentage
      ? obj.publisher2Percentage
      : this.publisher2Percentage;
    this.publisher3 =
      obj.publisher3 !== undefined ? obj.publisher3 : this.publisher3;
    this.publisher3Percentage = obj.publisher3Percentage
      ? obj.publisher3Percentage
      : this.publisher3Percentage;
    this.publisher4 =
      obj.publisher4 !== undefined ? obj.publisher4 : this.publisher4;
    this.publisher4Percentage = obj.publisher4Percentage
      ? obj.publisher4Percentage
      : this.publisher4Percentage;
    this.publisher5 =
      obj.publisher5 !== undefined ? obj.publisher5 : this.publisher5;
    this.publisher5Percentage = obj.publisher5Percentage
      ? obj.publisher5Percentage
      : this.publisher5Percentage;
    this.publisher6 =
      obj.publisher6 !== undefined ? obj.publisher6 : this.publisher6;
    this.publisher6Percentage = obj.publisher6Percentage
      ? obj.publisher6Percentage
      : this.publisher6Percentage;
    this.publisher7 =
      obj.publisher7 !== undefined ? obj.publisher7 : this.publisher7;
    this.publisher7Percentage = obj.publisher7Percentage
      ? obj.publisher7Percentage
      : this.publisher7Percentage;
    this.publisher8 =
      obj.publisher8 !== undefined ? obj.publisher8 : this.publisher8;
    this.publisher8Percentage = obj.publisher8Percentage
      ? obj.publisher8Percentage
      : this.publisher8Percentage;
    this.publisher9 =
      obj.publisher9 !== undefined ? obj.publisher9 : this.publisher9;
    this.publisher9Percentage = obj.publisher9Percentage
      ? obj.publisher9Percentage
      : this.publisher9Percentage;
    this.publisher10 =
      obj.publisher10 !== undefined ? obj.publisher10 : this.publisher10;
    this.publisher10Percentage = obj.publisher10Percentage
      ? obj.publisher10Percentage
      : this.publisher10Percentage;
    this.publisher11 =
      obj.publisher11 !== undefined ? obj.publisher11 : this.publisher11;
    this.publisher11Percentage = obj.publisher11Percentage
      ? obj.publisher11Percentage
      : this.publisher11Percentage;
    this.publisher12 =
      obj.publisher12 !== undefined ? obj.publisher12 : this.publisher12;
    this.publisher12Percentage = obj.publisher12Percentage
      ? obj.publisher12Percentage
      : this.publisher12Percentage;
    this.publisher13 =
      obj.publisher13 !== undefined ? obj.publisher13 : this.publisher13;
    this.publisher13Percentage = obj.publisher13Percentage
      ? obj.publisher13Percentage
      : this.publisher13Percentage;
    this.publisher14 =
      obj.publisher14 !== undefined ? obj.publisher14 : this.publisher14;
    this.publisher14Percentage = obj.publisher14Percentage
      ? obj.publisher14Percentage
      : this.publisher14Percentage;
    this.publisher15 =
      obj.publisher15 !== undefined ? obj.publisher15 : this.publisher15;
    this.publisher15Percentage = obj.publisher15Percentage
      ? obj.publisher15Percentage
      : this.publisher15Percentage;
    this.publisher16 =
      obj.publisher16 !== undefined ? obj.publisher16 : this.publisher16;
    this.publisher16Percentage = obj.publisher16Percentage
      ? obj.publisher16Percentage
      : this.publisher16Percentage;
    this.publisher17 =
      obj.publisher17 !== undefined ? obj.publisher17 : this.publisher17;
    this.publisher17Percentage = obj.publisher17Percentage
      ? obj.publisher17Percentage
      : this.publisher17Percentage;
    this.publisher18 =
      obj.publisher18 !== undefined ? obj.publisher18 : this.publisher18;
    this.publisher18Percentage = obj.publisher18Percentage
      ? obj.publisher18Percentage
      : this.publisher18Percentage;
    this.publisher19 =
      obj.publisher19 !== undefined ? obj.publisher19 : this.publisher19;
    this.publisher19Percentage = obj.publisher19Percentage
      ? obj.publisher19Percentage
      : this.publisher19Percentage;
    this.publisher20 =
      obj.publisher20 !== undefined ? obj.publisher20 : this.publisher20;
    this.publisher20Percentage = obj.publisher20Percentage
      ? obj.publisher20Percentage
      : this.publisher20Percentage;
    this.publisher21 =
      obj.publisher21 !== undefined ? obj.publisher21 : this.publisher21;
    this.publisher21Percentage = obj.publisher21Percentage
      ? obj.publisher21Percentage
      : this.publisher21Percentage;
    this.publisher22 =
      obj.publisher22 !== undefined ? obj.publisher22 : this.publisher22;
    this.publisher22Percentage = obj.publisher22Percentage
      ? obj.publisher22Percentage
      : this.publisher22Percentage;
    this.publisher23 =
      obj.publisher23 !== undefined ? obj.publisher23 : this.publisher23;
    this.publisher23Percentage = obj.publisher23Percentage
      ? obj.publisher23Percentage
      : this.publisher23Percentage;
    this.publisher24 =
      obj.publisher24 !== undefined ? obj.publisher24 : this.publisher24;
    this.publisher24Percentage = obj.publisher24Percentage
      ? obj.publisher24Percentage
      : this.publisher24Percentage;
    this.publisher25 =
      obj.publisher25 !== undefined ? obj.publisher25 : this.publisher25;
    this.publisher25Percentage = obj.publisher25Percentage
      ? obj.publisher25Percentage
      : this.publisher25Percentage;
    this.publisher26 =
      obj.publisher26 !== undefined ? obj.publisher26 : this.publisher26;
    this.publisher26Percentage = obj.publisher26Percentage
      ? obj.publisher26Percentage
      : this.publisher26Percentage;
    this.publisher27 =
      obj.publisher27 !== undefined ? obj.publisher27 : this.publisher27;
    this.publisher27Percentage = obj.publisher27Percentage
      ? obj.publisher27Percentage
      : this.publisher27Percentage;
    this.albumName =
      obj.albumName !== undefined ? obj.albumName : this.albumName;
    this.primaryReleaseDate =
      obj.primaryReleaseDate !== undefined
        ? obj.primaryReleaseDate
        : this.primaryReleaseDate;
    this.releaseArtistName =
      obj.releaseArtistName !== undefined
        ? obj.releaseArtistName
        : this.releaseArtistName;
    this.projectName =
      obj.projectName !== undefined ? obj.projectName : this.projectName;
    this.trackName =
      obj.trackName !== undefined ? obj.trackName : this.trackName;
    this.trackArtistName =
      obj.trackArtistName !== undefined
        ? obj.trackArtistName
        : this.trackArtistName;
    this.isrcNumber =
      obj.isrcNumber !== undefined ? obj.isrcNumber : this.isrcNumber;
    this.discNumber =
      obj.discNumber !== undefined ? obj.discNumber : this.discNumber;
    this.sideNumber =
      obj.sideNumber !== undefined ? obj.sideNumber : this.sideNumber;
    this.trackNumber =
      obj.trackNumber !== undefined ? obj.trackNumber : this.trackNumber;
    this.musicMaestroId =
      obj.musicMaestroId !== undefined
        ? obj.musicMaestroId
        : this.musicMaestroId;
    this.openPlayId =
      obj.openPlayId !== undefined ? obj.openPlayId : this.openPlayId;
    this.uploadId = obj.uploadId !== undefined ? obj.uploadId : this.uploadId;
    return this;
  }
}
